import { Typography, useTheme } from '@mui/material';

import { useLocalization } from '../../../localization';

type Props = {
  label: string;
  required?: boolean;
  styles?: React.CSSProperties;
  subLabel?: { [key: string]: string | number };
};
const TextFormLabel = (props: Props) => {
  const { label, required = false, styles, subLabel } = props;
  const { t } = useLocalization();
  const { palette } = useTheme();

  return (
    <Typography
      sx={{
        fontWeight: 500,
        letterSpacing: '-0.03rem',
        lineHeight: 'normal',
        ...styles,
      }}
    >
      {t(label, subLabel)}
      {required && <span style={{ color: palette.error.light }}> * </span>}
    </Typography>
  );
};

export default TextFormLabel;
